import { forwardRef } from 'react';
import { Badge, badgeClasses, BadgeProps, IconProps, styled } from '@mui/material';
import classNames from 'classnames';

import { IconOption } from '@components/base';

import { Icon } from './Icon';

export type IconBadgeProps = Omit<BadgeProps, 'badgeContent'> &
  Pick<IconProps, 'fontSize'> & {
    icon: IconOption;
    transparentBackground?: boolean;
  };

const StyledBadge = styled(Badge)`
  &.transparent {
    .${badgeClasses.badge} {
      background: transparent;
    }
  }

  .${badgeClasses.badge} {
    border-radius: 50%;
    padding: 0;
  }
`;

export const IconBadge = forwardRef<HTMLDivElement, IconBadgeProps>(
  ({ className, children, color, icon, fontSize, transparentBackground, ...rest }, ref) => (
    <StyledBadge
      badgeContent={
        <Icon
          color={transparentBackground ? (color as IconProps['color']) : 'inherit'}
          fontSize={fontSize ?? (transparentBackground ? undefined : 'inherit')}
          name={icon}
        />
      }
      className={classNames(className, { transparent: transparentBackground })}
      color={color}
      ref={ref}
      {...rest}
    >
      {children}
    </StyledBadge>
  )
);
